// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles
import { gridSize } from '@atlassian/jira-common-styles/src';

export const SMALL_BROWSER_BREAKPOINT = 1280;

export const ISSUE_TABLE_ROW_INNER_HEIGHT = gridSize * 4;

export const NO_EPIC_DISPLAYED_NAME = 'unassigned' as const;
export const DEBOUNCE_MILLISECONDS = 300;
export const jiraReleasesExperimentalApiHeader = {
	'X-ExperimentalApi': 'jira-releases-v0',
} as const;

export const NUM_ISSUES_PER_PAGE = 1000;
